<div class="">
    <div class="sectionlabel">Dining Times & Locations</div>
    <div class="tenpxtop"></div>
    <div class="diningblurb">
        All dining is open seating during the times shown.
    </div>
    <div class="tenpxtop"></div>
    <div class="mealarea">
        <div class="mealrows" *ngFor="let mealtime of MealtimesInfo; let i=index;">
            <div class="mealarearow row">
                <div class="col-1"></div>
                <div class="col-10">
                    <div class="mealname"> {{mealtime.aiiActivityName}}</div>
                    <div class="mealtimelocation ">
                        <span class="mealtime"> {{mealtime.aiibegtime | timepipe}} - {{mealtime.aiiendtime |
                            timepipe}}</span>
                    </div>
                    <div class="tenpxtop"></div>
                    <div class="meal"> {{mealtime.aiiActivityDesc}}</div>

                </div>
                <div class="tenpxtop"></div>
            </div>

        </div>

    </div>
</div>